<template>
    <div class="flex float-left vertical-center">
        <vs-chip class="line-0" v-bind:color="statusColor">
            <vs-avatar style="background: hsla(0, 0%, 100%, .2)" v-bind:icon="statusIcon" />
            {{ statusText }}
        </vs-chip>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "StatusActiveAgGridComponent",
    data() {
        return {
            statusColor: '',
            statusText: '',
            statusIcon: '',
        }
    },
    mounted() {

        if (this.params.value !== '' && this.params.value !== null && this.params.value !== undefined) {
            if (this.params.value) {
                this.statusColor = 'success'
                this.statusText = 'Active'
                this.statusIcon = 'verified_user'
            } else {
                this.statusIcon = 'close'
                this.statusColor = 'danger'
                this.statusText = 'Not Active'
            }
        }
    }
})
</script>

<style scoped>
/* .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    } */

.vertical-center {
    margin: 0;
    position: absolute;
    top: 25px;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}

.line-0 {
    line-height: 0;
}
</style>